import React from 'react';
import { Avatar, AvatarVariant } from "../avatar/Avatar.js";
import { jsx as _jsx } from "react/jsx-runtime";
const AvatarAutoColors = AvatarVariant.filter(item => item !== 'GRAY');
export const generateAvatarVariantFromString = string => {
  let number = 0;
  for (let x = 0; x < string.length; x++) {
    number += string.charCodeAt(x);
  }
  return AvatarAutoColors[number % AvatarAutoColors.length];
};
export function PersonAvatar({
  className,
  size,
  name,
  seed
}) {
  const variant = generateAvatarVariantFromString(seed);
  return /*#__PURE__*/_jsx(Avatar, {
    name: name || '?',
    className: className,
    size: size,
    variant: variant
  });
}